import styled, { css } from 'styled-components';

export const SubTitle = styled.span`
  padding: 16px;
  color: #505150;
`;

export const SelectLabel = styled.span`
  margin-left: 6px;
  color: #e71037;
  cursor: pointer;
`;

export const InputFileHidden = styled.input.attrs({ type: 'file' })`
  display: none;
`;

export const Line = styled.div`
  width: 100%;
  height: 1px;
  background-color: #cccc;
  margin-top: 16px;
  margin-bottom: 16px;
`;

export const BoxDrag = styled.div`
  padding: 16px;
  border: 1px dashed #d6d6d6;
  border-radius: 6px;
  margin-bottom: 20px;
  margin-top: 8px;
`;

export const BoxDragIcon = styled.img`
  height: 35px;
  width: 35px;
  margin-top: 6px;
  margin-bottom: 16px;
`;

export const BoxCard = styled.div`
  width: 100%;
  padding: 24px;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 10px 26px rgb(0 0 0 / 5%);
`;

export const Title = styled.h1`
  font-size: 1.3rem;
  font-weight: 700;
  color: #2e3958;
  margin-bottom: 24px;
`;
export const selectedButton = css`
  border: 1px solid #e4003a;
  background-color: #e4003a08;
`;
export const ButtonSelectTypeUpload = styled.div.attrs({ role: 'button' })`
  border: 1px solid #e6e6e6;
  min-height: 130px;
  min-height: 130px;
  max-width: 200px;
  flex: 1;
  max-height: 200px;
  padding: 16px 8px;
  border-radius: 16px;
  cursor: pointer;
  display: flex;
  text-align: center;
  gap: 8px;
  transition: all 0.3ms ease;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  position: relative;
  .radio-container {
    position: absolute;
    top: 6px;
    right: 4px;
  }
  ${({ selected }) => (selected ? selectedButton : null)};

  .img-container {
    width: 48px;
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;

    background-color: #e4003a;
    img {
      width: 24px;
      height: 24px;
      object-fit: contain;
    }
  }
  span {
    font-weight: 600;
  }
`;

export const TableWrapper = styled.div`
  overflow-x: auto;
  max-height: 500px;
  overflow-y: auto;
`;

export const ZeussTable = styled.table`
  width: 100%;
  border-collapse: separate;
  border-spacing: 0 10px;
  background-color: transparent;
`;

export const ZeussHeaderCell = styled.th<{
  first?: boolean;
  last?: boolean;
}>`
  text-align: center;
  padding: 12px;
  background-color: #e8eaed;
  color: #5f6368;
  font-weight: 600;
  ${({ first }) =>
    first
      ? `
    border-top-left-radius: 8px;
    border-bottom-left-radius: 8px;
  `
      : ''}
  ${({ last }) =>
    last
      ? `
    border-top-right-radius: 8px;
    border-bottom-right-radius: 8px;
  `
      : ''}
`;

export const ZeussRow = styled.tr`
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
`;

export const ZeussCell = styled.td<{
  first?: boolean;
  last?: boolean;
}>`
  padding: 22px;
  text-align: center;
  background-color: #fff;
  ${({ first }) =>
    first
      ? `
    border-top-left-radius: 8px;
    border-bottom-left-radius: 8px;
  `
      : ''}
  ${({ last }) =>
    last
      ? `
    border-top-right-radius: 8px;
    border-bottom-right-radius: 8px;
  `
      : ''}

    .delete-button {
    padding: 8px;
    border-radius: 8px;
    cursor: pointer;
    transition: all 200ms ease-in;
    :hover {
      scale: 1.1;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    }
  }
`;

export const ZeussEmptyCell = styled.td`
  padding: 12px;
  text-align: center;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
`;
